export default __webpack_public_path__ + "static/media/eye-mask.c2cc0f45.svg";